<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import ContaPagarReceber from '@/src/services/conta-pagar-receber'
import CategoriaConta from '@/src/services/categoria-conta'
import CentroCusto from '@/src/services/centro-custo'
import TipoConta from '@/src/services/tipo-conta'
import produtor from '@/src/services/produtor-rural'
import { VMoney } from 'v-money'
import moment from 'moment'
moment.locale('pt-br')
var currencyFormatter = require('currency-formatter')

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading },
  directives: { money: VMoney },
  data() {
    return {
      filter: '',
      mostraForm: true,
      isLoading: false,
      idDelete: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      accountFrequency: [
        { value: 'semanalmente', text: 'Semanalmente' },
        { value: 'quinzenalmente', text: 'Quinzenalmente' },
        { value: 'mensalmente', text: 'Mensalmente' },
      ],
      numberOccurrences: [
        { value: '1', text: '1 vez' },
        { value: '2', text: '2 vezes' },
        { value: '3', text: '3 vezes' },
        { value: '4', text: '4 vezes' },
        { value: '5', text: '5 vezes' },
        { value: '6', text: '6 vezes' },
        { value: '7', text: '7 vezes' },
        { value: '8', text: '8 vezes' },
        { value: '9', text: '9 vezes' },
        { value: '10', text: '10 vezes' },
        { value: '11', text: '11 vezes' },
        { value: '12', text: '12 vezes' },
      ],
      contasApagar: [],
      categoriasConta: [],
      centroCusto: [],
      tiposConta: [],
      produtores: [],
      contaAPagarEdit: {
        frquencySelected: 'mensalmente',
      },
      contasAPagarField: [
        {
          key: 'descricao',
          label: 'Descrição',
          //class: 'size-col-20',
        },
        {
          key: 'data_competencia',
          label: 'Competência',
          //class: 'size-col-20',
        },
        {
          key: 'data_vencimento',
          label: 'Vencimento',
          //class: 'size-col-20',
        },
        {
          key: 'valor',
          label: 'Valor',
          //class: 'size-col-20',
        },
        {
          key: 'diff',
          label: 'Status',
          //class: 'size-col-20',
        },
        { key: 'actions', label: '' /*class: 'size-col-10'*/ },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
    }
  },
  computed: {},

  watch: {
    currentPage() {
      this.listando()
    },
    'contaAPagarEdit.desconto_taxa': function () {
      if (this.contaAPagarEdit.pago) this.calcularValorTotal()
    },
    'contaAPagarEdit.juro_multa': function () {
      if (this.contaAPagarEdit.pago) this.calcularValorTotal()
    },
    'contaAPagarEdit.valor': function () {
      if (this.contaAPagarEdit.pago) this.calcularValorTotal()
    },
    'contaAPagarEdit.pago': function () {
      this.contaAPagarEdit.valor_final = ''
      if (this.contaAPagarEdit.pago) {
        this.contaAPagarEdit.valor_final = this.contaAPagarEdit.valor
      }
    },
    mostraForm() {
      if (this.mostraForm) {
        this.listando()
      }
    },
  },
  mounted() {
    this.listando()
    this.handleGet()
  },
  methods: {
    calcularValorTotal() {
      var valor = currencyFormatter.unformat(this.contaAPagarEdit.valor, {
        locale: 'pt-BR',
        code: 'BRL',
      })
      var taxa = currencyFormatter.unformat(
        this.contaAPagarEdit.desconto_taxa,
        {
          locale: 'pt-BR',
          code: 'BRL',
        }
      )
      var multa = currencyFormatter.unformat(this.contaAPagarEdit.juro_multa, {
        locale: 'pt-BR',
        code: 'BRL',
      })
      var valorCalculado = valor - taxa - multa

      this.contaAPagarEdit.valor_final = currencyFormatter.format(
        valorCalculado,
        {
          locale: 'pt-BR',
          code: 'BRL',
        }
      )
    },
    handleGet() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      CategoriaConta.listar(token)
        .then((resposta) => {
          this.categoriasConta = resposta.data.categorias
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
      CentroCusto.listar(token)
        .then((resposta) => {
          this.centroCusto = resposta.data.centros
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
      TipoConta.listar(token)
        .then((resposta) => {
          this.isLoading = false
          this.tiposConta = resposta.data.tipoContas
        })
        .catch((error) => {
          this.isLoading = false
        })
      produtor
        .listar(token, this.filter)
        .then((resposta) => {
          this.produtores = resposta.data.data
          this.isLoading = false
        })
        .catch((error) => {
          this.produtores = []
          this.isLoading = false
        })
    },
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    diffDate(date) {
      var given = moment.utc(date, 'YYYY-MM-DD')
      var current = moment.utc().startOf('day')
      return moment.duration(given.diff(current)).asDays()
    },
    listando() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      ContaPagarReceber.listar(token, 'PAGAR', this.currentPage, this.perPage)
        .then((resposta) => {
          this.contasApagar = resposta.data.contas
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    cadastra() {
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listar()
      }
    },
    editRegister(categoriaConta) {
      this.contaAPagarEdit = categoriaConta
      this.mostraForm = false
    },
    salvar() {
      const token = this.$store.state.auth.currentUser.token
      this.contaAPagarEdit.tipo_operacao = 'PAGAR'
      if (this.contaAPagarEdit.id) {
        this.isLoading = true
        ContaPagarReceber.atualizarConta(token, this.contaAPagarEdit)
          .then((resposta) => {
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = false
          })
          .catch((erro) => {
            this.$bvToast.toast(
              erro.response
                ? erro.response.data.message.join(', ')
                : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.isLoading = true
        ContaPagarReceber.salvar(token, this.contaAPagarEdit)
          .then((resposta) => {
            this.isLoading = false
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.mensagem, {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            }
            this.contaAPagarEdit = {}
          })
          .catch((erro) => {
            this.$bvToast.toast(
              erro.response
                ? erro.response.data.message.join(', ')
                : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    modalDelete(id) {
      this.$bvModal.show('modal-delete')
      this.idDelete = id
    },
    handleDelete() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      ContaPagarReceber.deleteConta(token, this.idDelete)
        .then((reposta) => {
          this.$bvToast.toast('Conta excluída', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.isLoading = false
          this.listando()
        })
        .catch((err) => {
          this.$bvModal.hide('modal-delete')
          this.isLoading = false
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idDelete = null
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-10 mb-3">
            <div class="titulo">Contas Pagar</div>
            <div class="subTitulo">
              Registre todos os pagamentos a ser realizados.
            </div>
          </div>
          <div class="col-md-2">
            <div class="float-right">
              <button class="btn btn-primary" @click="cadastra">
                <span v-if="mostraForm">Novo</span>
                <span v-else>Visualizar Contas a Pagar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div class="row" v-if="mostraForm">
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Descrição" label-for="filter">
            <b-form-input
              id="filter"
              v-model="filter"
              type="text"
              placeholder="Digite o filtro de busca"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div v-if="mostraForm">
        <div class="col-md-12">
          <div class="float-right">
            <div class="description found"
              ><b>Total de Registros: {{ this.rows }}</b>
            </div>
          </div>
        </div>
        <b-table
          striped
          hover
          responsive
          borderless
          bordered
          outlined
          small
          :items="contasApagar"
          :fields="contasAPagarField"
          :per-page="perPage"
          :filter="filter"
        >
          <template v-slot:cell(actions)="row">
            <div class="btn-group mb-2">
              <button
                v-b-tooltip.hover
                title="Editar"
                type="button"
                class="btn btn-light"
                @click="editRegister(row.item)"
              >
                <i class="uil uil-edit"></i>
              </button>
              <button
                v-b-tooltip.hover
                title="Deletar"
                type="button"
                class="btn btn-light"
                @click="modalDelete(row.item.id)"
              >
                <i class="uil uil-trash-alt"></i>
              </button>
            </div>
          </template>
          <template v-slot:cell(ativo)="row">{{
            row.item.ativo ? 'Sim' : 'Não'
          }}</template>
          <template v-slot:cell(data_competencia)="row">
            {{
              formatDate(row.item.data_competencia) !== 'Invalid date'
                ? formatDate(row.item.data_competencia)
                : row.item.data_competencia
            }}
          </template>
          <template v-slot:cell(data_vencimento)="row">
            {{
              formatDate(row.item.data_vencimento) !== 'Invalid date'
                ? formatDate(row.item.data_vencimento)
                : row.item.data_vencimento
            }}
          </template>
          <template v-slot:cell(diff)="row">
            <b-badge
              v-if="diffDate(row.item.data_vencimento) > 1"
              variant="info"
              class="pl-2 pr-2 pt-1 pb-1"
              >NO PRAZO</b-badge
            >
            <b-badge
              v-else-if="row.item.pago"
              variant="primary"
              class="pl-2 pr-2 pt-1 pb-1"
              >PAGO</b-badge
            >
            <b-badge
              v-else-if="diffDate(row.item.data_vencimento) < 0"
              variant="danger"
              class="pl-2 pr-2 pt-1 pb-1"
              >VENCIDA</b-badge
            >
            <b-badge v-else variant="warning" class="pl-2 pr-2 pt-1 pb-1"
              >VENCE HOJE</b-badge
            >
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          size="md"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>

      <div v-else>
        <b-form>
          <div class="row flex-column flex-md-row">
            <div class="col col-md-8 order-2 order-md-1">
              <div class="row flex-column flex-md-row">
                <div class="col">
                  <b-form-group label="Descrição">
                    <b-form-input v-model="contaAPagarEdit.descricao" />
                  </b-form-group>
                </div>
                <div class="col">
                  <b-form-group label="Categoria">
                    <v-select
                      class="style-select"
                      label="descricao"
                      :options="categoriasConta"
                      :reduce="(item) => item.id"
                      v-model="contaAPagarEdit.id_categoria"
                      :dense="true"
                    ></v-select>
                  </b-form-group>
                </div>
              </div>
              <div class="row flex-column flex-md-row">
                <div class="col">
                  <b-form-group label="Conta">
                    <v-select
                      class="style-select"
                      label="tipo"
                      :options="tiposConta"
                      :reduce="(item) => item.id"
                      v-model="contaAPagarEdit.id_tipo_conta"
                      :dense="true"
                    ></v-select>
                  </b-form-group>
                </div>
                <div class="col">
                  <b-form-group label="Data da competência">
                    <b-form-datepicker
                      id="datepicker-competencia"
                      v-model="contaAPagarEdit.data_competencia"
                      placeholder=""
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      locale="pt-br"
                    >
                      <template v-slot:button-content>
                        <b-icon icon="calendar" variant="primary"></b-icon>
                      </template>
                    </b-form-datepicker>
                  </b-form-group>
                </div>
                <div class="col">
                  <b-form-group label="Data do vencimento">
                    <b-form-datepicker
                      id="datepicker-vencimento"
                      v-model="contaAPagarEdit.data_vencimento"
                      placeholder=""
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      locale="pt-br"
                    >
                      <template v-slot:button-content>
                        <b-icon icon="calendar" variant="primary"></b-icon>
                      </template>
                    </b-form-datepicker>
                  </b-form-group>
                </div>
                <div class="col">
                  <b-form-group label="Valor">
                    <b-form-input
                      v-model.lazy="contaAPagarEdit.valor"
                      v-money="money"
                    />
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="borda"></div>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-12">
                  <b-form-checkbox v-model="contaAPagarEdit.repetir">
                    Repetir conta
                  </b-form-checkbox>
                </div>
              </div>

              <div class="row" v-show="contaAPagarEdit.repetir">
                <div class="row pl-2 align-items-end">
                  <div class="col">
                    <b-form-select
                      v-model="contaAPagarEdit.frquencySelected"
                      :options="accountFrequency"
                    >
                    </b-form-select>
                  </div>
                  <!-- <div class="col-2">
                    <label for="">Ocorrências</label>
                  </div>
                  <div class="col-2">
                    <b-form-input v-model="contaAPagarEdit.ocorrencias" />
                  </div> -->
                  <div class="col-4">
                    <label for="">Quantas vezes?</label>
                  </div>
                  <div class="col-3">
                    <b-form-select
                      v-model="contaAPagarEdit.vezes"
                      :options="numberOccurrences"
                    >
                    </b-form-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="borda"></div>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-12">
                  <b-form-checkbox v-model="contaAPagarEdit.pago">
                    Pago
                  </b-form-checkbox>
                </div>
              </div>

              <div class="row" v-show="contaAPagarEdit.pago">
                <div class="row flex-wrap pl-2 align-items-end">
                  <div class="col-12 col-md">
                    <b-form-group label="Data">
                      <b-form-datepicker
                        id="datepicker-recebimento"
                        v-model="contaAPagarEdit.data_recebimento"
                        placeholder=""
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                        locale="pt-br"
                      >
                        <template v-slot:button-content>
                          <b-icon icon="calendar" variant="primary"></b-icon>
                        </template>
                      </b-form-datepicker>
                    </b-form-group>
                  </div>
                  <div class="col-4 col-md">
                    <b-form-group label="Desconto / Taxas">
                      <b-form-input
                        v-model.lazy="contaAPagarEdit.desconto_taxa"
                        v-money="money"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-4 col-md">
                    <b-form-group label="Juros / Multa">
                      <b-form-input
                        v-model.lazy="contaAPagarEdit.juro_multa"
                        v-money="money"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-4 col-md">
                    <b-form-group label="Valor Final">
                      <b-form-input
                        disabled
                        class="bg-light"
                        v-model="contaAPagarEdit.valor_final"
                      />
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
            <div class="col col-md-4 order-1 order-md-2 border-left">
              <div class="row">
                <div class="col">
                  <b-form-group label="Cliente">
                    <v-select
                      class="style-select"
                      label="nome"
                      :options="produtores"
                      :reduce="(item) => item.id_produtor_rural"
                      v-model="contaAPagarEdit.id_cliente"
                      :dense="true"
                    ></v-select>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <b-form-group label="Centro de custo">
                    <v-select
                      class="style-select"
                      label="descricao"
                      :options="centroCusto"
                      :reduce="(item) => item.id"
                      v-model="contaAPagarEdit.id_centro_custo"
                      :dense="true"
                    ></v-select>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <b-form-group label="Observações">
                    <b-form-textarea
                      id="textarea"
                      v-model="contaAPagarEdit.obs"
                      placeholder="Informações extras..."
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                </div>
              </div>
              <!-- <div class="row">
                <div class="col">
                  <b-form-group label="Anexos"> Em breve... </b-form-group>
                </div>
              </div> -->
            </div>
          </div>
          <b-button type="submit" variant="primary" @click.prevent="salvar"
            >Salvar</b-button
          >
        </b-form>
      </div>
    </div>

    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>
    <loading
      :active.sync="isLoading"
      color="#008e75"
      :can-cancel="false"
    ></loading>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>